import React, { useRef } from 'react'
import styles from './Flow.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  contents: {
    num: number
    title: string
    description: string
    src: string
  }[]
}

const Flow: React.FC<Props> = ({ contents }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.flow} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.flow__title}>ご利用の流れ</h2>
        <ul className={styles.flowList}>
          {contents.map((item, i) => (
            <li key={i} className={styles.flowList__item}>
              <div className={styles.flowList__item__cts}>
                <figure className={styles.flowList__item__cts__image}>
                  <img src={item.src} alt="" />
                </figure>
                <div className={styles.flowList__item__cts__text}>
                  <h3 className={styles.flowList__item__cts__text__title}>{item.title}</h3>
                  <p className={styles.flowList__item__cts__text__description}>{item.description}</p>
                </div>
              </div>
              {i < contents.length - 1 && (
                <div className={styles.flowList__item__arrow}>
                  <img src="/images/LP/LP202407/Icon/BsCaretDownFill.svg" alt="next" />
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
export default Flow
